var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1668 20.1666L18.3335 18.3333M10.5418 19.2499C11.6854 19.2499 12.8178 19.0247 13.8744 18.587C14.9309 18.1494 15.8909 17.5079 16.6995 16.6993C17.5082 15.8907 18.1496 14.9307 18.5873 13.8741C19.0249 12.8176 19.2502 11.6852 19.2502 10.5416C19.2502 9.39799 19.0249 8.26559 18.5873 7.20905C18.1496 6.15251 17.5082 5.19251 16.6995 4.38386C15.8909 3.57522 14.9309 2.93377 13.8744 2.49613C12.8178 2.0585 11.6854 1.83325 10.5418 1.83325C8.23224 1.83325 6.01724 2.75073 4.38411 4.38386C2.75098 6.01699 1.8335 8.23199 1.8335 10.5416C1.8335 12.8512 2.75098 15.0662 4.38411 16.6993C6.01724 18.3324 8.23224 19.2499 10.5418 19.2499Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1668 20.1666L18.3335 18.3333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.38d567f855a7594dae47ffcb73611045.svg";
export { ForwardRef as ReactComponent };